module.exports = __webpack_public_path__ + "static/media/alex.b73e6d7c.jpg";